import axios from 'axios';
import { get } from './client';

export function getElevationUploadUrl(growerId, fileName) {
  return get(`/growers/${growerId}/elevation/signed-upload-url/${fileName}`);
}

export function uploadElevation(signedUrl, file, onProgress) {
  return axios.put(signedUrl, file, {
    headers: { 'Content-Type': 'image/tiff' },
    onUploadProgress: (progressEvent) => onProgress(progressEvent),
  });
}
